module.exports = __webpack_public_path__ + "img/4.cff4745f.jpg";